import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Quagga from '@ericblade/quagga2';
var defaultConstraints = {
  width: 1080,
  height: 720
};
var defaultLocatorSettings = {
  patchSize: 'medium',
  halfSample: true,
  willReadFrequently: true
};
var defaultDecoders = ['code_128_reader', 'ean_reader', 'ean_8_reader', 'code_39_reader'];

var Scanner = function Scanner(_ref) {
  var onDetected = _ref.onDetected,
      scannerRef = _ref.scannerRef;
  var onDetectedCallback = useCallback(function (result) {
    var _result$codeResult;

    if (!onDetected) {
      return;
    }

    if (/^\d{17}$/i.test(result === null || result === void 0 ? void 0 : (_result$codeResult = result.codeResult) === null || _result$codeResult === void 0 ? void 0 : _result$codeResult.code)) {
      onDetected(result.codeResult.code);
    }
  }, [onDetected]);
  useLayoutEffect(function () {
    // if this component gets unmounted in the same tick that it is mounted, then all hell breaks loose,
    // so we need to wait 1 tick before calling init().  I'm not sure how to fix that, if it's even possible,
    // given the asynchronous nature of the camera functions, the non asynchronous nature of React, and just how
    // awful browsers are at dealing with cameras.
    var ignoreStart = false;

    var init = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });

              case 2:
                if (!ignoreStart) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return Quagga.init({
                  inputStream: {
                    type: 'LiveStream',
                    constraints: _objectSpread(_objectSpread({}, defaultConstraints), {}, {
                      facingMode: 'environment'
                    }),
                    target: scannerRef.current,
                    willReadFrequently: true
                  },
                  locator: defaultLocatorSettings,
                  decoder: {
                    readers: defaultDecoders
                  },
                  locate: true
                }, /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(err) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!err) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", console.error('Error starting Quagga:', err));

                          case 2:
                            if (!(scannerRef && scannerRef.current)) {
                              _context.next = 5;
                              break;
                            }

                            _context.next = 5;
                            return Quagga.start();

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 6:
                _context2.next = 8;
                return Quagga.onDetected(onDetectedCallback);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function init() {
        return _ref2.apply(this, arguments);
      };
    }();

    init(); // cleanup by turning off the camera and any listeners

    return function () {
      ignoreStart = true;
      Quagga.stop();
      Quagga.offDetected(onDetectedCallback);
    };
  }, [onDetected, scannerRef]);
  return null;
};

Scanner.propTypes = {
  onDetected: PropTypes.func.isRequired,
  scannerRef: PropTypes.object.isRequired
};
export default Scanner;